<!--
  Prenotazione — dettaglio: le TRATTE a sinistra, dove si lavora, il
  riepilogo sticky a destra.

  ⚠️ UN BOOKING HA PIÙ TRATTE, in tre collezioni diverse a seconda del
  servizio: pickup_bookings / escort_bookings / delivery_bookings. I punti si
  chiamano in modo diverso in ognuna, e per il PICKUP la tratta ha un capo
  solo (l'indirizzo del cliente): l'altro è sempre la sede del partner. Qui la
  normalizzazione sta in un posto solo (`toLeg`).

  ⚠️ ORARI — pickup, escort e delivery usano la stessa colonna `datetime`:
  si formattano tutti in ora locale, come la lista (vedi `hhmm`).

  ⚠️ L'assegnazione driver/jolly NON sta sulla tratta ma sui `planner`
  (GET /driver/planner/:bookingId): ogni planner ha un `raceId` che è l'id
  della tratta, ed è così che qui vengono ricongiunti.
-->
<template>
  <div
    v-loading="loading"
    class="bkd"
  >
    <!-- ---------- intestazione ---------- -->
    <div class="bkd__head">
      <button
        type="button"
        class="bkd__back"
        @click="goBack"
      >
        ‹
      </button>
      <div class="bkd__ident">
        <h1 class="bkd__title">
          Prenotazione
          <StatusPill
            :kind="headState.kind"
            :label="headState.label"
          />
        </h1>
        <div class="bkd__sub">
          <ServiceChip :service="service" />
          <span class="bkd__id">#{{ shortId }}</span>
          <span v-if="booking.data">· {{ dLabel(booking.data) }}</span>
          <span v-if="partnerName">· {{ partnerName }}</span>
        </div>
      </div>
      <div class="bkd__spacer" />
      <div class="bkd__actions">
        <el-button
          type="danger"
          plain
          @click="confirmDelete"
        >
          Elimina prenotazione
        </el-button>
      </div>
    </div>

    <!-- Il dettaglio dello stato è più fine della pill: va detto per esteso. -->
    <div
      v-if="stateDetail"
      class="bkd__stateNow"
    >
      <span class="bkd__stateDot" />
      {{ stateDetail }}
    </div>

    <div
      v-if="loanerBanner"
      class="warnbox"
    >
      <span class="warnbox__ico">⚠</span>
      <div class="warnbox__txt">
        {{ loanerBanner }}
      </div>
    </div>

    <div class="bkd__grid">
      <!-- ================= COLONNA PRINCIPALE ================= -->
      <div class="bkd__col">
        <!-- ---------- tratte ---------- -->
        <section
          v-for="leg in legs"
          :key="leg.id"
          class="bkd__card"
        >
          <header class="bkd__cardHead">
            <h3>{{ leg.title }}</h3>
            <span
              class="bkd__legTag"
              :class="`bkd__legTag--${leg.direction}`"
            >{{ leg.direction === 'gone' ? 'Andata' : 'Ritorno' }}</span>
            <div class="bkd__spacer" />
            <el-button
              v-if="puoCambiareIndirizzo(leg)"
              size="small"
              @click="openAddrDialog(leg)"
            >
              Cambia indirizzo
            </el-button>
            <el-button
              size="small"
              @click="openDateDialog(leg)"
            >
              Modifica data e ora
            </el-button>
          </header>
          <div class="bkd__cardBody">
            <div class="bkd__legTop">
              <div class="bkd__when">
                <span class="bkd__whenD">{{ dLabel(leg.depart || leg.date) }}</span>
                <span class="bkd__whenH">
                  {{ hhmm(leg.depart || leg.date) }}<template v-if="leg.arrive"> → {{ hhmm(leg.arrive) }}</template>
                </span>
              </div>
              <div class="bkd__route">
                <div class="bkd__pt">
                  <span class="bkd__pin bkd__pin--from" />
                  <span class="bkd__addr">{{ leg.from || '—' }}</span>
                </div>
                <div class="bkd__pt">
                  <span class="bkd__pin bkd__pin--to" />
                  <span class="bkd__addr">{{ leg.to || '—' }}</span>
                </div>
              </div>
              <div
                v-if="leg.kmRange"
                class="bkd__km"
              >
                <span class="bkd__kmN">{{ leg.kmRange }}</span>
                <span class="bkd__kmL">fascia km</span>
              </div>
            </div>

            <!-- ---------- driver e jolly ---------- -->
            <div class="bkd__assignHead">
              <h4>Driver e jolly</h4>
              <div class="bkd__spacer" />
              <!-- Chi è assegnato ADESSO sta sulla tratta (driver_pickup /
                   driver_escort / driver_delivery) e c'è sempre, anche quando
                   i planner non sono stati generati. -->
              <div
                v-if="leg.driver"
                class="bkd__drv"
              >
                <span class="bkd__drvAva">{{ ini(leg.driver) }}</span>
                <span>{{ leg.driver }}</span>
              </div>
              <span
                v-else
                class="bkd__unassigned"
              >Driver non assegnato</span>
            </div>

            <!-- Tendina vuota: dire perché, invece di lasciar pensare che i
                 driver non esistano. -->
            <p
              v-if="driversError"
              class="bkd__hint bkd__hint--warn"
            >
              {{ driversError }}
            </p>

            <!-- assegnazione: una riga per planner (driver o jolly) -->
            <div class="bkd__assign">
              <div
                v-for="pl in leg.planners"
                :key="pl.plannerId"
                class="bkd__pl"
              >
                <span
                  class="bkd__plRole"
                  :class="{ 'bkd__plRole--jolly': !pl.isDriver }"
                >{{ pl.isDriver ? 'Driver' : 'Jolly' }}</span>
                <div class="bkd__plWhen">
                  {{ pl.data_inizio }} → {{ pl.data_fine }}
                </div>
                <el-select
                  v-model="pl.driverId"
                  placeholder="Non assegnato"
                  filterable
                  clearable
                  size="small"
                  class="bkd__plSel"
                >
                  <el-option
                    v-for="d in drivers"
                    :key="d.id"
                    :label="`${d.name} ${d.surname}`"
                    :value="d.id"
                  />
                </el-select>
                <el-button
                  size="small"
                  type="primary"
                  :disabled="!pl.driverId"
                  :loading="savingPlanner === pl.plannerId"
                  @click="saveDriver(pl)"
                >
                  Salva
                </el-button>
              </div>
              <!-- ⚠️ QUI NON SI CREANO PLANNER. I planner nascono una volta
                   sola, alla creazione della prenotazione (POST
                   /planner/best-driver), con gli orari calcolati dal motore:
                   questa pagina può solo cambiare CHI è assegnato a quelli
                   che esistono. Crearne altri li duplicherebbe, con orari
                   inventati dalla tratta invece che dal planner. -->
              <p
                v-if="!leg.planners.length && plannersError"
                class="bkd__empty bkd__empty--attn"
              >
                Planner non caricati ({{ plannersError }}): finché la chiamata
                non risponde non si può cambiare l'assegnazione.
              </p>
              <p
                v-else-if="!leg.planners.length"
                class="bkd__empty"
              >
                Nessun planner su questa tratta. I planner nascono con la
                prenotazione, insieme al calcolo del driver: se non ci sono,
                la corsa non è mai stata pianificata e l'assegnazione va
                rifatta ricreando la prenotazione.
              </p>
            </div>
          </div>
        </section>

        <p
          v-if="!legs.length && !loading"
          class="bkd__card bkd__cardBody bkd__empty"
        >
          Questa prenotazione non ha tratte.
        </p>

        <!-- Planner che non corrispondono a nessuna tratta: restano
             assegnabili qui. -->
        <section
          v-if="orphanPlanners.length"
          class="bkd__card"
        >
          <header class="bkd__cardHead">
            <h3>Altre assegnazioni</h3>
            <span class="bkd__count">{{ orphanPlanners.length }}</span>
          </header>
          <div class="bkd__cardBody">
            <p class="bkd__empty bkd__mb">
              Questi planner non risultano legati a nessuna tratta di questa
              prenotazione, ma restano assegnabili.
            </p>
            <div class="bkd__assign bkd__assign--flush">
              <div
                v-for="pl in orphanPlanners"
                :key="pl.plannerId"
                class="bkd__pl"
              >
                <span
                  class="bkd__plRole"
                  :class="{ 'bkd__plRole--jolly': !pl.isDriver }"
                >{{ pl.isDriver ? 'Driver' : 'Jolly' }}</span>
                <div class="bkd__plWhen">
                  {{ pl.data_inizio }} → {{ pl.data_fine }}
                </div>
                <el-select
                  v-model="pl.driverId"
                  placeholder="Non assegnato"
                  filterable
                  clearable
                  size="small"
                  class="bkd__plSel"
                >
                  <el-option
                    v-for="d in drivers"
                    :key="d.id"
                    :label="`${d.name} ${d.surname}`"
                    :value="d.id"
                  />
                </el-select>
                <el-button
                  size="small"
                  type="primary"
                  :disabled="!pl.driverId"
                  :loading="savingPlanner === pl.plannerId"
                  @click="saveDriver(pl)"
                >
                  Salva
                </el-button>
              </div>
            </div>
          </div>
        </section>

        <!-- ---------- mezzo e noleggio (solo Transfer) ---------- -->
        <!-- `vehicle_type` e `passengers` stanno sul BOOKING. Il
             noleggio invece è un record a parte (`vehicle_rental`, M9): un
             Transfer può usare più mezzi, e ognuno ha il suo fornitore, costo
             e stato di pagamento. `booking.supplier_cost` è la SOMMA dei
             noleggi, riallineata dal backend: qui è solo da leggere. -->
        <section
          v-if="isTransfer"
          class="bkd__card"
        >
          <header class="bkd__cardHead">
            <h3>Mezzo e noleggio</h3>
            <div class="bkd__spacer" />
            <el-button
              size="small"
              @click="openEdit('mezzo')"
            >
              Modifica
            </el-button>
          </header>
          <div class="bkd__cardBody">
            <div class="bkd__kv">
              <span>Mezzo</span>
              <b :class="{ 'bkd__missing': !booking.vehicle_type }">
                {{ vehicleLabel || 'non indicato' }}
              </b>
            </div>
            <div class="bkd__kv">
              <span>Passeggeri</span>
              <b :class="{ 'bkd__missing': !booking.passengers }">
                {{ booking.passengers || 'non indicati' }}
              </b>
            </div>

            <div class="bkd__rentals">
              <div class="bkd__rentalsHead">
                <span>Noleggi</span>
                <span class="bkd__spacer" />
                <el-button
                  size="small"
                  @click="openRental"
                >
                  ＋ Registra noleggio
                </el-button>
              </div>

              <div
                v-if="rentalsLoading"
                class="bkd__hint"
              >
                Caricamento…
              </div>
              <div
                v-else-if="rentalsForbidden"
                class="bkd__hint bkd__hint--attn"
              >
                I noleggi sono un costo interno Simba: servono i permessi di
                superadmin per vederli.
              </div>
              <!-- L'avviso vale solo per i mezzi che si noleggiano: per
                   l'auto del partner o la nostra un noleggio non esiste, e
                   segnalarne l'assenza sarebbe rumore. -->
              <div
                v-else-if="!rentals.length && isRentableVehicle"
                class="bkd__hint bkd__hint--attn"
              >
                Nessun noleggio registrato: se il mezzo è stato preso da un
                fornitore, il costo <b>non</b> entra nel COD8.
              </div>
              <div
                v-else-if="!rentals.length"
                class="bkd__hint"
              >
                Nessun noleggio: questo mezzo non si prende da un fornitore.
              </div>

              <div
                v-for="r in rentals"
                :key="r.id"
                class="bkd__rental"
              >
                <div class="bkd__rentalMain">
                  <b>{{ r.supplier?.company_name || 'Fornitore sconosciuto' }}</b>
                  <span class="bkd__rentalMeta">
                    {{ vehicleLabelOf(r.vehicle_type) || '—' }}
                    <template v-if="r.rental_date">· {{ dLabel(r.rental_date) }}</template>
                  </span>
                </div>
                <span class="bkd__rentalCost">{{ euro(r.cost) }}</span>
                <StatusPill
                  :kind="r.status === 'paid' ? 'ok' : 'attn'"
                  :label="r.status === 'paid' ? 'Pagato' : 'Da pagare'"
                />
              </div>

              <div
                v-if="rentals.length"
                class="bkd__rentalTot"
              >
                <span>Costo fornitori</span>
                <b>{{ euro(rentalsTotal) }}</b>
              </div>
            </div>
          </div>
        </section>

        <!-- ---------- stato ---------- -->
        <section class="bkd__card">
          <header class="bkd__cardHead">
            <h3>Stato della prenotazione</h3>
          </header>
          <div class="bkd__cardBody">
            <div class="bkd__stateRow">
              <el-select
                v-model="stateDraft"
                placeholder="Scegli lo stato"
                style="width: 100%; max-width: 420px"
              >
                <el-option
                  v-for="o in stateOptions"
                  :key="o.value"
                  :label="o.label"
                  :value="o.value"
                />
              </el-select>
              <el-button
                type="primary"
                :disabled="!stateDraft || stateDraft === booking.state"
                :loading="savingState"
                @click="saveState"
              >
                Salva stato
              </el-button>
            </div>
            <p class="bkd__hint">
              Forzatura manuale della macchina a stati del driver: da usare
              quando l'app driver non ha registrato un passaggio.
            </p>
          </div>
        </section>

        <!-- ---------- pagamenti in app ---------- -->
        <section
          v-if="tasks.length"
          class="bkd__card"
        >
          <header class="bkd__cardHead">
            <h3>Lavorazioni</h3>
            <span class="bkd__count">{{ tasks.length }}</span>
          </header>
          <div class="bkd__cardBody">
            <!-- ⚠️ DUE CAMPI DIVERSI, non confonderli:
                 `pay`      = la voce va pagata IN APP (decide se al cliente
                              arriva la notifica pay_task_* o solo quella da
                              accettare);
                 `accepted` = il cliente HA SALDATO ("impostare che il cliente
                              ha pagato", booking.service.ts). -->
            <div
              v-for="(t, i) in tasks"
              :key="i"
              class="bkd__task"
            >
              <span class="bkd__taskD">{{ t.description || 'Lavorazione' }}</span>
              <span
                v-if="t.pay"
                class="bkd__taskApp"
              >in app</span>
              <StatusPill
                :kind="taskState(t).kind"
                :label="taskState(t).label"
              />
              <span class="bkd__taskC">{{ euro(t.cost) }}</span>
            </div>
            <div class="bkd__task bkd__task--tot">
              <span class="bkd__taskD">Totale</span>
              <span class="bkd__taskC">{{ euro(tasksTotal) }}</span>
            </div>
            <div
              v-if="tasksDue > 0"
              class="bkd__task bkd__task--due"
            >
              <span class="bkd__taskD">Ancora da saldare</span>
              <span class="bkd__taskC">{{ euro(tasksDue) }}</span>
            </div>
          </div>
        </section>

        <!-- ---------- note ---------- -->
        <section class="bkd__card">
          <header class="bkd__cardHead">
            <h3>Note</h3>
            <div class="bkd__spacer" />
            <el-button
              size="small"
              @click="openEdit('note')"
            >
              Modifica
            </el-button>
          </header>
          <div class="bkd__cardBody">
            <p
              v-if="!carDescription && !note"
              class="bkd__empty"
            >
              Nessuna nota.
            </p>
            <div
              v-if="carDescription"
              class="bkd__field"
            >
              <span class="bkd__label">Descrizione auto</span>
              <span class="bkd__value">{{ carDescription }}</span>
            </div>
            <div
              v-if="note"
              class="bkd__field"
            >
              <span class="bkd__label">Note del cliente</span>
              <span class="bkd__value bkd__value--note">{{ note }}</span>
            </div>
          </div>
        </section>

        <!-- ---------- foto e allegati ---------- -->
        <!-- Le foto del driver stanno sulla TRATTA (pickup/delivery, 4 slot per
             riga `image`); gli allegati liberi (scontrini, foto extra) sul
             booking. Gli URL sono pre-firmati e scadono: si rileggono a ogni
             apertura della pagina. -->
        <section class="bkd__card">
          <header class="bkd__cardHead">
            <h3>Foto e allegati</h3>
            <span class="bkd__count">{{ photoCount + attachments.length }}</span>
          </header>
          <div class="bkd__cardBody">
            <MediaGallery
              :groups="photoGroups"
              :attachments="attachments"
              :loading="mediaLoading"
              :error="mediaError"
              editable
              :uploading="uploadingAttachment"
              :max-mb="MAX_ALLEGATO_MB"
              empty-text="Nessuna foto o allegato per questa prenotazione."
              @upload="caricaAllegato"
              @remove="eliminaAllegato"
            />
          </div>
        </section>
      </div>

      <!-- ================= RIEPILOGO STICKY ================= -->
      <aside class="bkd__aside">
        <section class="bkd__card">
          <header class="bkd__cardHead">
            <h3>Cliente</h3>
            <div class="bkd__spacer" />
            <el-button
              v-if="bookingAperta"
              size="small"
              @click="custDialog = true"
            >
              Modifica
            </el-button>
          </header>
          <div class="bkd__cardBody">
            <div class="bkd__cust">
              <span class="bkd__avatar">{{ initials }}</span>
              <div class="bkd__custName">
                {{ customerName }}
              </div>
            </div>
            <div class="bkd__kv">
              <span>Telefono</span>
              <b>{{ booking.customer?.telephone_number || '—' }}</b>
            </div>
            <div class="bkd__kv">
              <span>Email</span>
              <b>{{ booking.customer?.mail || '—' }}</b>
            </div>
            <el-button
              v-if="booking.customer?.id"
              size="small"
              class="bkd__wide"
              @click="openCustomer"
            >
              Apri scheda cliente
            </el-button>
          </div>
        </section>

        <section
          v-if="booking.car"
          class="bkd__card"
        >
          <header class="bkd__cardHead">
            <h3>Auto</h3>
            <div class="bkd__spacer" />
            <el-button
              v-if="bookingAperta"
              size="small"
              @click="custDialog = true"
            >
              Cambia
            </el-button>
          </header>
          <div class="bkd__cardBody">
            <div class="bkd__kv">
              <span>Modello</span>
              <b>{{ carLabel }}</b>
            </div>
            <div class="bkd__kv">
              <span>Targa</span>
              <b class="bkd__plate">{{ booking.car?.targa || '—' }}</b>
            </div>
            <div
              v-if="booking.loaner"
              class="bkd__kv"
            >
              <span>Cortesia</span>
              <b>Auto di cortesia richiesta</b>
            </div>
          </div>
        </section>

        <section class="bkd__card">
          <header class="bkd__cardHead">
            <h3>Partner e sede</h3>
            <div class="bkd__spacer" />
            <!-- Anche a prenotazione conclusa (per correggere chi paga), non
                 se annullata o già fatturata al partner. -->
            <el-button
              v-if="puoCambiarePartner"
              size="small"
              @click="partnerDialog = true"
            >
              Modifica
            </el-button>
          </header>
          <div class="bkd__cardBody">
            <div class="bkd__kv">
              <span>Partner</span>
              <b>{{ partnerName || '—' }}</b>
            </div>
            <div class="bkd__kv">
              <span>Sede</span>
              <b>{{ booking.headquarter?.name || booking.headquarter?.city || '—' }}</b>
            </div>
            <p class="bkd__addrSmall">
              {{ hqAddress || '—' }}
            </p>
            <!-- Chi l'ha presa: il backend lo scrive da chi era collegato, e
                 non cambia più con le modifiche. «Simba» quando non è stata
                 presa da un dipendente del partner (gestionale o app cliente). -->
            <div class="bkd__kv">
              <span>Presa da</span>
              <b>{{ nomeDipendente(booking.employee) || 'Simba' }}</b>
            </div>
          </div>
        </section>

        <!-- COMPENSI DEI DRIVER, una riga per gamba.
             Il campo nasce precompilato con la tariffa dell'agenzia (ore ×
             tariffa oraria): scriverci dentro sostituisce quel calcolo per
             QUELLA gamba, ed è come si paga un notturno. Solo Simba: al
             partner il server risponde 403 e la card non compare. -->
        <section
          v-if="!compForbidden"
          class="bkd__card"
        >
          <header class="bkd__cardHead">
            <h3>Compensi driver</h3>
          </header>
          <div class="bkd__cardBody">
            <div
              v-if="compLoading"
              class="bkd__hint"
            >
              Caricamento…
            </div>
            <div
              v-else-if="!compLegs.length"
              class="bkd__hint"
            >
              Nessuna gamba pianificata: il compenso si decide quando la
              prenotazione ha le sue tratte.
            </div>

            <div
              v-for="leg in compLegs"
              :key="leg.planner_id"
              class="bkd__comp"
            >
              <div class="bkd__compMain">
                <b>
                  {{ leg.direction === 'return' ? 'Ritorno' : 'Andata' }}
                  · {{ leg.driver || 'driver da assegnare' }}
                </b>
                <span class="bkd__compMeta">
                  {{ leg.role === 'jolly' ? 'Jolly' : 'Conducente' }}
                  <template v-if="leg.agency">· {{ leg.agency }}</template>
                  <template v-if="leg.hours">· {{ leg.hours }} h</template>
                  <template v-if="leg.hourly_rate">× {{ euro(leg.hourly_rate) }}/h</template>
                  <template v-if="leg.night">· notturna</template>
                </span>
              </div>
              <el-input
                v-model="compDraft[leg.planner_id]"
                class="bkd__compInput"
                :placeholder="euro(leg.computed)"
                :aria-label="`Compenso ${leg.direction === 'return' ? 'ritorno' : 'andata'}`"
              />
            </div>

            <p
              v-if="compLegs.length"
              class="bkd__hint"
            >
              I campi partono dal calcolo dell'agenzia ({{ euro(compComputedTotal) }} in tutto):
              correggili dove serve. Svuotandone uno, quella tratta torna al calcolo.
              Il rimborso km del jolly resta a parte.
            </p>
            <!-- Nessuna IVA qui: il compenso del driver è un COSTO, non una
                 fattura al cliente. L'importo scritto è quello che il driver
                 prende, e in contabilità entra tale e quale. -->
            <div
              v-if="compLegs.length"
              class="bkd__rentalTot"
            >
              <span>Totale compensi <small>senza IVA</small></span>
              <b>{{ euro(compTotal) }}</b>
            </div>
            <el-button
              v-if="compLegs.length"
              type="primary"
              :loading="compSaving"
              @click="saveCompensations"
            >
              Salva compensi
            </el-button>
          </div>
        </section>

        <!-- PREZZO della prenotazione: `imponibile` e `tot_fattura` sono quelli
             del booking. Sul Transfer il prezzo al cliente è deciso a mano e
             sta a parte, in `customer_price`. -->
        <section class="bkd__card">
          <header class="bkd__cardHead">
            <h3>Prezzo</h3>
            <div class="bkd__spacer" />
            <!-- Solo il Transfer ha il prezzo scritto a mano: gli altri
                 servizi hanno il listino, e le correzioni passano dal COD3. -->
            <el-button
              v-if="isTransfer"
              size="small"
              @click="openEdit('prezzo')"
            >
              Modifica
            </el-button>
          </header>
          <div class="bkd__cardBody">
            <div class="bkd__kv">
              <span>Imponibile</span>
              <b>{{ booking.imponibile != null ? euro(booking.imponibile) : '—' }}</b>
            </div>
            <div class="bkd__kv">
              <span>IVA</span>
              <b>{{ booking.imponibile != null && booking.tot_fattura != null
                ? euro(Number(booking.tot_fattura) - Number(booking.imponibile))
                : '—' }}</b>
            </div>
            <div class="bkd__kv">
              <span>Totale fattura</span>
              <b>{{ booking.tot_fattura != null ? euro(booking.tot_fattura) : '—' }}</b>
            </div>
            <!-- Fascia km: `simba_km_range` è il limite della fascia con cui
                 è nato il prezzo, `simba_km` la distanza calcolata. Stanno
                 sulle tratte: una riga per tratta se le fasce sono diverse. -->
            <div
              v-for="row in kmBandRows"
              :key="row.key"
              class="bkd__kv"
            >
              <span>{{ row.label }}</span>
              <b>{{ row.value }}</b>
            </div>
            <div
              v-if="booking.customer_price != null"
              class="bkd__kv"
            >
              <span>Prezzo al cliente</span>
              <b>{{ euro(booking.customer_price) }}</b>
            </div>
          </div>
        </section>

      </aside>
    </div>

    <!-- ---------- modifica data e ora di una tratta ---------- -->
    <el-dialog
      v-model="dateDialog"
      :title="dateDialogTitle"
      width="520px"
    >
      <p class="bkd__hint bkd__hint--top">
        Gli orari proposti sono quelli con un driver libero: il calcolo tiene
        conto del percorso e della zona. Alla conferma il cliente riceve la
        notifica del cambio.
      </p>
      <div class="bkd__form">
        <div class="bkd__formField">
          <label>Nuova data</label>
          <el-date-picker
            v-model="newDate"
            type="date"
            placeholder="gg/mm/aaaa"
            format="DD/MM/YYYY"
            value-format="YYYY-MM-DD"
            style="width: 100%"
            @change="reloadSlots"
          />
        </div>
        <div class="bkd__formField">
          <label>Nuovo orario</label>
          <el-select
            v-model="newSlot"
            v-loading="slotsLoading"
            placeholder="Scegli l'orario"
            :disabled="!newDate || slotsLoading"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="s in slots"
              :key="s.value"
              :label="s.value"
              :value="s.value"
              :disabled="s.disabled"
            />
          </el-select>
          <p
            v-if="newDate && !slotsLoading && !freeSlotCount"
            class="bkd__hint bkd__hint--attn"
          >
            Nessun orario disponibile in questa giornata.
          </p>
        </div>
      </div>
      <template #footer>
        <el-button @click="dateDialog = false">
          Annulla
        </el-button>
        <el-button
          type="primary"
          :disabled="!newDate || !newSlot"
          :loading="savingDate"
          @click="saveDate"
        >
          Sposta la tratta
        </el-button>
      </template>
    </el-dialog>

    <LegAddressDialog
      v-model="addrDialog"
      :booking-id="booking.id || ''"
      :leg="addrLeg"
      @saved="load"
    />
    <CustomerCarDialog
      v-model="custDialog"
      :booking="booking"
      @saved="load"
    />
    <PartnerSedeDialog
      v-model="partnerDialog"
      :booking="booking"
      @saved="load"
    />

    <!-- ------------------- modifica dati della prenotazione ------------------- -->
    <!-- Note, mezzo e prezzo del Transfer: campi della prenotazione. Tratte,
         driver e planner restano come sono. -->
    <el-dialog
      v-model="editDialog"
      :title="editTitle"
      width="520px"
    >
      <div class="bkd__form">
        <template v-if="editKind === 'note'">
          <div
            v-if="carDescription"
            class="bkd__field"
          >
            <span class="bkd__label">Descrizione auto</span>
            <span class="bkd__value">{{ carDescription }}</span>
          </div>
          <div class="bkd__fld">
            <label>Note</label>
            <el-input
              v-model="editDraft.note"
              type="textarea"
              :rows="4"
              maxlength="1000"
              show-word-limit
              placeholder="Indicazioni per il driver, riferimenti, documenti…"
            />
          </div>
        </template>

        <div
          v-else-if="editKind === 'mezzo'"
          class="bkd__grid2"
        >
          <div class="bkd__fld">
            <label>Mezzo</label>
            <el-select
              v-model="editDraft.vehicleType"
              placeholder="Non indicato"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="v in VEHICLES"
                :key="v.value"
                :label="v.label"
                :value="v.value"
              />
            </el-select>
          </div>
          <div class="bkd__fld">
            <label>Passeggeri</label>
            <el-input-number
              v-model="editDraft.passengers"
              :min="0"
              :max="99"
              controls-position="right"
              style="width: 100%"
            />
          </div>
          <p
            v-if="troppiPasseggeri"
            class="bkd__hint bkd__hint--attn"
          >
            {{ troppiPasseggeri }}
          </p>
        </div>

        <template v-else-if="editKind === 'prezzo'">
          <div class="bkd__fld">
            <label>Totale fattura <span class="bkd__opt">(IVA inclusa)</span></label>
            <el-input
              v-model="editDraft.lordo"
              inputmode="decimal"
              placeholder="0,00"
            >
              <template #append>
                €
              </template>
            </el-input>
          </div>
          <div class="bkd__kv">
            <span>Imponibile</span>
            <b>{{ lordoValido ? euro(imponibileDaLordo) : '—' }}</b>
          </div>
          <div class="bkd__kv">
            <span>IVA 22%</span>
            <b>{{ lordoValido ? euro(lordoNumero - imponibileDaLordo) : '—' }}</b>
          </div>
          <p
            v-if="booking.imponibile_manuale != null || booking.totale_manuale != null"
            class="bkd__hint bkd__hint--attn"
          >
            Nel COD3 questa prenotazione ha un importo corretto a mano: vale
            quello finché non lo togli dal COD3.
          </p>
        </template>
      </div>
      <template #footer>
        <el-button @click="editDialog = false">
          Annulla
        </el-button>
        <el-button
          type="primary"
          :disabled="editKind === 'prezzo' && !lordoValido"
          :loading="savingEdit"
          @click="saveEdit"
        >
          Salva
        </el-button>
      </template>
    </el-dialog>

    <!-- ------------------------ registra noleggio ------------------------- -->
    <el-dialog
      v-model="rentalDialog"
      title="Registra noleggio del mezzo"
      width="560px"
    >
      <div class="bkd__form">
        <div class="bkd__fld">
          <label>Fornitore</label>
          <el-select
            v-model="rentalDraft.supplierId"
            placeholder="Scegli il fornitore"
            filterable
            style="width: 100%"
            :loading="suppliersLoading"
          >
            <el-option
              v-for="s in suppliers"
              :key="s.id"
              :label="s.company_name"
              :value="s.id"
            />
          </el-select>
          <p
            v-if="!suppliersLoading && !suppliers.length"
            class="bkd__hint bkd__hint--attn"
          >
            Nessun fornitore attivo: va creato prima, dalla sezione Fornitori.
          </p>
        </div>
        <div class="bkd__grid2">
          <div class="bkd__fld">
            <label>Mezzo</label>
            <el-select
              v-model="rentalDraft.vehicleType"
              style="width: 100%"
            >
              <el-option
                v-for="v in VEHICLES"
                :key="v.value"
                :label="v.label"
                :value="v.value"
              />
            </el-select>
          </div>
          <div class="bkd__fld">
            <label>Data del noleggio</label>
            <el-date-picker
              v-model="rentalDraft.rentalDate"
              type="date"
              value-format="YYYY-MM-DD"
              style="width: 100%"
            />
          </div>
        </div>
        <div class="bkd__fld">
          <label>Costo <span class="bkd__opt">(quanto paghiamo noi)</span></label>
          <el-input
            v-model.number="rentalDraft.cost"
            type="number"
            step="0.01"
            min="0"
          >
            <template #append>
              €
            </template>
          </el-input>
        </div>
        <p class="bkd__hint">
          Nasce «da pagare» ed entra nel resoconto COD8 del mese della data
          indicata. Il pagamento si registra da lì, a fattura ricevuta.
        </p>
      </div>
      <template #footer>
        <el-button @click="rentalDialog = false">
          Annulla
        </el-button>
        <el-button
          type="primary"
          :disabled="!rentalDraft.supplierId"
          :loading="savingRental"
          @click="saveRental"
        >
          Registra
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import bookingAPI from '../../services/bookingAPI.js';
import driverAPI from '../../services/driverAPI.js';
import prenotazioneAPI from '../../services/prenotazioneAPI.js';
import StatusPill from '../../components/ui/StatusPill.vue';
import ServiceChip from '../../components/ui/ServiceChip.vue';
import MediaGallery from '../../components/ui/MediaGallery.vue';
import LegAddressDialog from '../../components/booking/LegAddressDialog.vue';
import CustomerCarDialog from '../../components/booking/CustomerCarDialog.vue';
import PartnerSedeDialog from '../../components/booking/PartnerSedeDialog.vue';
import supplierAPI from '../../services/supplierAPI.js';
import { toInstant } from '../../services/datetime.js';
import { MAX_ALLEGATO_MB, leggiComeDataUri, troppoGrande } from '../../services/fileUpload.js';
import { VEHICLES, VEHICLE_LABELS, vehicleOf } from '../../services/vehicleTypes.js';

// Stato del booking -> pill, come nella lista: gli stati intermedi della
// macchina a stati del driver sono decine e valgono tutti "in corso".
function headStateOf(state) {
  if (state === 'end') return { kind: 'muted', label: 'Concluso' };
  if (state === 'canceled') return { kind: 'danger', label: 'Annullato' };
  if (state === 'before') return { kind: 'attn', label: 'Non ancora confermata' };
  if (state === 'accepted') return { kind: 'ok', label: 'Accettato' };
  return { kind: 'active', label: 'In corso' };
}

// Etichetta per esteso dello stato corrente (la macchina a stati del driver).
//
// ⚠️ Questo elenco deve coprire TUTTI i valori dell'enum `booking.state`: uno
// stato senza etichetta non dà errore, mostra una stringa VUOTA — e chi guarda
// la prenotazione non capisce a che punto sia. Confrontato con l'enum reale
// (migrazione Baseline, 48 valori): ne mancavano due, `partnerAEscort` e
// `canceled`, entrambi raggiungibilissimi — il primo è l'ultimo passo
// dell'andata di un Transfer, il secondo è ogni prenotazione annullata.
const STATE_LABELS = {
  before: 'Non ancora confermata',
  accepted: 'Accettato dal cliente',
  end: 'Concluso',
  canceled: 'Annullata',

  startAPickup: 'Andata · driver in viaggio',
  driverScanJollyAPickup: 'Andata · jolly e driver presso la sede',
  customerAPickup: 'Andata · driver arrivato dal cliente',
  photoAPickup: 'Andata · il driver ha fatto le foto',
  scanAPickup: "Andata · il driver ha ritirato l'auto",
  partnerAPickup: 'Andata · driver arrivato dal partner',
  startRPickup: 'Ritorno · driver in viaggio',
  partnerRPickup: 'Ritorno · driver arrivato dal partner',
  customerRPickup: 'Ritorno · driver arrivato dal cliente',
  photoRPickup: 'Ritorno · il driver ha fatto le foto',
  scanRPickup: "Ritorno · il driver ha consegnato l'auto",
  driverScanJollyRPickup: 'Ritorno · jolly presso il cliente',

  startAPickupLoaner: 'Andata · driver in arrivo',
  partnerAPickupLoaner: "Andata · il driver ha ritirato l'auto di cortesia",
  customerAPickupLoaner: 'Andata · driver arrivato dal cliente',
  photoAPickupLoaner: 'Andata · il driver ha fatto le foto',
  scanAPickupLoaner: "Andata · il cliente ha ritirato l'auto di cortesia",
  partnersecondAPickupLoaner: 'Andata · driver arrivato dal partner',
  startRPickupLoaner: 'Ritorno · driver in arrivo',
  partnerRPickupLoaner: "Ritorno · il driver ha ritirato l'auto di cortesia",
  customerRPickupLoaner: 'Ritorno · driver arrivato dal cliente',
  photoRPickupLoaner: 'Ritorno · il driver ha fatto le foto',
  scanRPickupLoaner: "Ritorno · il cliente ha ritirato l'auto di cortesia",

  startADelivery: 'Andata · driver in viaggio',
  partnerADelivery: "Andata · il driver ha ritirato l'auto",
  photofirstADelivery: 'Andata · il driver ha fatto le foto',
  customerADelivery: 'Andata · driver arrivato al punto di consegna',
  photosecondADelivery: "Andata · il driver ha consegnato l'auto",
  driverScanJollyADelivery: 'Andata · il jolly ha accompagnato il driver',
  startRDelivery: 'Ritorno · driver in viaggio',
  customerRDelivery: "Ritorno · il driver ha ritirato l'auto",
  photofirstRDelivery: 'Ritorno · il driver ha fatto le foto',
  partnerRDelivery: 'Ritorno · driver arrivato al punto di consegna',
  photosecondRDelivery: "Ritorno · il driver ha consegnato l'auto",
  driverScanJollyRDelivery: 'Ritorno · il jolly ha accompagnato il driver',

  startAEscort: 'Andata · driver in viaggio',
  customerAEscort: 'Andata · driver al punto di incontro',
  scanfirstAEscort: 'Andata · cliente salito in auto',
  scanssecondAEscort: 'Andata · cliente portato a destinazione',
  // la doppia «s» sopra e la singola in `scansecondREscort` NON sono un
  // refuso del gestionale: sono i nomi veri nell'enum del database.
  partnerAEscort: 'Andata · driver arrivato dal partner',
  startREscort: 'Ritorno · driver in viaggio',
  customerREscort: 'Ritorno · driver al punto di incontro',
  scanfirstREscort: 'Ritorno · cliente salito in auto',
  scansecondREscort: 'Ritorno · cliente portato a destinazione',
};

// Stati impostabili a mano, per famiglia di servizio. Le etichette 'A -' e
// 'R -' distinguono andata e ritorno, e le voci del ritorno si mostrano solo
// se la tratta esiste.
const ACCEPTED = { value: 'accepted', label: 'Accettato' };

// ⚠️ OGNI `value` qui sotto deve esistere nell'enum `booking.state` a database.
// Per il jolly si usano i `driverScanJolly*`: i `driverShowJolly*` della
// roadmap dell'app non esistono nell'enum e non si possono salvare.
const STATE_OPTIONS = {
  pickup: {
    gone: [
      ACCEPTED,
      { value: 'startAPickup', label: 'A - Driver in viaggio' },
      { value: 'driverScanJollyAPickup', label: 'A - Jolly e driver presso la sede' },
      { value: 'customerAPickup', label: 'A - Driver arrivato al cliente' },
      { value: 'photoAPickup', label: 'A - Il driver ha fatto le foto' },
      { value: 'scanAPickup', label: "A - Il driver ha ritirato l'auto" },
      { value: 'partnerAPickup', label: 'A - Il driver è arrivato dal partner' },
    ],
    return: [
      { value: 'startRPickup', label: 'R - Driver in viaggio' },
      { value: 'partnerRPickup', label: 'R - Driver arrivato dal partner' },
      { value: 'customerRPickup', label: 'R - Driver arrivato dal cliente' },
      { value: 'photoRPickup', label: 'R - Il driver ha fatto le foto' },
      { value: 'scanRPickup', label: "R - Il driver ha consegnato l'auto" },
      { value: 'driverScanJollyRPickup', label: 'R - Jolly presso il cliente' },
    ],
  },
  pickup_loaner: {
    gone: [
      ACCEPTED,
      { value: 'startAPickupLoaner', label: 'A - Driver in viaggio' },
      { value: 'partnerAPickupLoaner', label: 'A - Driver ritira auto di cortesia' },
      { value: 'customerAPickupLoaner', label: 'A - Driver arrivato al cliente' },
      { value: 'photoAPickupLoaner', label: 'A - Il driver ha fatto le foto' },
      { value: 'scanAPickupLoaner', label: "A - Il driver ha ritirato l'auto" },
      { value: 'partnersecondAPickupLoaner', label: 'A - Il driver è arrivato dal partner' },
    ],
    return: [
      { value: 'startRPickupLoaner', label: 'R - Driver in viaggio' },
      { value: 'partnerRPickupLoaner', label: 'R - Driver arrivato dal partner' },
      { value: 'customerRPickupLoaner', label: 'R - Driver arrivato dal cliente' },
      { value: 'photoRPickupLoaner', label: 'R - Il driver ha fatto le foto' },
      { value: 'scanRPickupLoaner', label: "R - Il driver ha consegnato l'auto" },
    ],
  },
  escort: {
    gone: [
      ACCEPTED,
      { value: 'startAEscort', label: 'A - Driver in viaggio' },
      { value: 'customerAEscort', label: 'A - Driver al punto di incontro col cliente' },
      { value: 'scanfirstAEscort', label: 'A - Il driver ha fatto salire il cliente' },
      { value: 'scanssecondAEscort', label: 'A - Cliente portato al punto stabilito' },
      { value: 'partnerAEscort', label: 'A - Driver arrivato dal partner' },
    ],
    return: [
      { value: 'startREscort', label: 'R - Driver in viaggio' },
      { value: 'customerREscort', label: 'R - Driver al punto di incontro col cliente' },
      { value: 'scanfirstREscort', label: 'R - Il driver ha fatto salire il cliente' },
      { value: 'scansecondREscort', label: 'R - Cliente portato al punto stabilito' },
    ],
  },
  delivery: {
    gone: [
      ACCEPTED,
      { value: 'startADelivery', label: 'A - Driver in viaggio' },
      { value: 'partnerADelivery', label: "A - Driver ha ritirato l'auto" },
      { value: 'photofirstADelivery', label: 'A - Il driver ha fatto le foto' },
      { value: 'customerADelivery', label: 'A - Driver al punto di consegna' },
      { value: 'photosecondADelivery', label: "A - Driver ha consegnato l'auto" },
      { value: 'driverScanJollyADelivery', label: 'A - Il jolly ha accompagnato il driver' },
    ],
    return: [
      { value: 'startRDelivery', label: 'R - Driver in viaggio' },
      { value: 'customerRDelivery', label: "R - Driver ha ritirato l'auto" },
      { value: 'photofirstRDelivery', label: 'R - Il driver ha fatto le foto' },
      { value: 'partnerRDelivery', label: 'R - Driver al punto di consegna' },
      { value: 'photosecondRDelivery', label: "R - Driver ha consegnato l'auto" },
    ],
  },
};

// Tipi accettati da /planner/slot-availables e dagli update di tratta
// (enum BookingType lato backend).
const SLOT_TYPE = {
  pickup: { gone: 'PICKUP_GONE', return: 'PICKUP_RETURN' },
  pickup_loaner: { gone: 'PICKUP_AUTO_GONE', return: 'PICKUP_AUTO_RETURN' },
  escort: { gone: 'ESCORT_GONE', return: 'ESCORT_RETURN' },
  escort_loaner: { gone: 'ESCORT_AUTO_GONE', return: 'ESCORT_AUTO_RETURN' },
  delivery: { gone: 'DELIVERY_GONE', return: 'DELIVERY_RETURN' },
};

const place = (p) =>
  p ? [p.address, p.street_number, p.cap, p.city, p.province]
    .filter(Boolean).join(' ').replace(/\s+/g, ' ').trim() : '';

// Slot da 08:00 a 18:45 ogni quarto d'ora: è la griglia che il backend usa
// per rispondere con gli orari liberi.
const ALL_SLOTS = (() => {
  const out = [];
  for (let m = 8 * 60; m <= 18 * 60 + 45; m += 15) {
    out.push(`${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`);
  }
  return out;
})();

export default {
  name: 'BookingDetailsPage',
  components: { StatusPill, ServiceChip, MediaGallery, LegAddressDialog, CustomerCarDialog, PartnerSedeDialog },

  setup() {
    const route = useRoute();
    const router = useRouter();
    // `let`: da una prenotazione all'altra il componente resta lo stesso.
    let id = route.params.id;

    const booking = ref({});
    const planners = ref([]);
    const drivers = ref([]);
    const loading = ref(false);
    const stateDraft = ref('');
    const savingState = ref(false);
    const savingPlanner = ref('');
    // Se i planner non arrivano, l'assegnazione non è possibile: meglio
    // dirlo in pagina che lasciare un riquadro vuoto.
    const plannersError = ref('');

    const dateDialog = ref(false);
    const dateLeg = ref(null);
    const newDate = ref('');
    const newSlot = ref('');
    const slots = ref([]);
    const slotsLoading = ref(false);
    const savingDate = ref(false);

    // ---- lettura ---------------------------------------------------------
    const shortId = computed(() => (booking.value.id || '').slice(0, 8));
    const headState = computed(() => headStateOf(booking.value.state));
    const stateDetail = computed(() => STATE_LABELS[booking.value.state] || '');

    // A UI il servizio "Notturno" è il type_booking 'restaurant'.
    // Il Transfer di un partner notturno resta un Transfer: `type_booking`
    // segue il partner, il servizio lo dice `type_prenotazione`.
    const service = computed(() => {
      const t = booking.value.type_prenotazione || 'pickup';
      if (t.startsWith('escort')) return t;
      return booking.value.type_booking === 'restaurant' ? 'restaurant' : t;
    });

    // ------------------------------------------------------------------
    //  Mezzo e noleggi (solo Transfer)
    //
    //  Due livelli diversi: mezzo e passeggeri sono SNAPSHOT sul booking
    //  (M7), i noleggi sono record propri (M9) con fornitore, costo e stato
    //  di pagamento. `booking.supplier_cost` è la somma dei noleggi e la
    //  riallinea il backend: qui non si scrive mai.
    // ------------------------------------------------------------------
    const isTransfer = computed(() => {
      const t = booking.value.type_prenotazione;
      return t === 'escort' || t === 'escort_loaner';
    });

    const vehicleLabelOf = (v) => VEHICLE_LABELS[v] || '';
    const vehicleLabel = computed(() => vehicleLabelOf(booking.value.vehicle_type));
    const isRentableVehicle = computed(() =>
      !!vehicleOf(booking.value.vehicle_type)?.rentable);

    const rentals = ref([]);
    const rentalsLoading = ref(false);
    const rentalsForbidden = ref(false);
    const rentalsTotal = computed(() =>
      rentals.value.reduce((sum, r) => sum + Number(r.cost || 0), 0));

    const loadRentals = async () => {
      if (!isTransfer.value || !booking.value.id) return;
      rentalsLoading.value = true;
      try {
        rentals.value = await supplierAPI.getRentalsByBooking(booking.value.id);
        rentalsForbidden.value = false;
      } catch (e) {
        // I noleggi sono riservati ai ruoli globali: un 403 non è un guasto
        // e non va mostrato come "nessun noleggio", che significa altro.
        rentalsForbidden.value = e?.response?.status === 403;
        if (!rentalsForbidden.value) console.error('Noleggi non caricati:', e);
        rentals.value = [];
      } finally {
        rentalsLoading.value = false;
      }
    };

    // ------------------------------------------------------------------
    //  Compensi dei driver, per gamba.
    //
    //  Il server manda `computed` (ore × tariffa oraria dell'agenzia) e
    //  `manual` (l'importo deciso a mano, se c'è). Nel campo si scrive solo
    //  quando si vuole sostituire il calcolo: vuoto = paga il calcolo.
    //  Riservato ai ruoli globali — un 403 nasconde la card invece di
    //  sembrare "nessun compenso".
    // ------------------------------------------------------------------
    const compLegs = ref([]);
    const compDraft = reactive({});
    const compLoading = ref(false);
    const compSaving = ref(false);
    const compForbidden = ref(false);

    const compComputedTotal = computed(() =>
      compLegs.value.reduce((s2, l) => s2 + Number(l.computed || 0), 0));
    // Il totale segue quello che si sta scrivendo, non l'ultimo salvataggio.
    const compTotal = computed(() =>
      compLegs.value.reduce((s2, l) => {
        const scritto = String(compDraft[l.planner_id] ?? '').trim();
        const importo = scritto === '' ? Number(l.computed || 0) : Number(scritto.replace(',', '.'));
        return s2 + (Number.isFinite(importo) ? importo : Number(l.computed || 0));
      }, 0));

    const loadCompensations = async () => {
      if (!booking.value.id) return;
      compLoading.value = true;
      try {
        const res = await bookingAPI.getDriverCompensation(booking.value.id);
        compLegs.value = res.data?.legs || [];
        for (const leg of compLegs.value) {
          // Il campo nasce PIENO col calcolo dell'agenzia: si corregge quel
          // numero invece di riscriverlo da zero. Vuoto = torna al calcolo.
          compDraft[leg.planner_id] = leg.manual === null || leg.manual === undefined
            ? String(leg.computed ?? 0)
            : String(leg.manual);
        }
        compForbidden.value = false;
      } catch (e) {
        compForbidden.value = e?.response?.status === 403;
        if (!compForbidden.value) console.error('Compensi non caricati:', e);
        compLegs.value = [];
      } finally {
        compLoading.value = false;
      }
    };

    const saveCompensations = async () => {
      const legs = [];
      for (const leg of compLegs.value) {
        const scritto = String(compDraft[leg.planner_id] ?? '').trim();
        if (scritto === '') {
          legs.push({ planner_id: leg.planner_id, amount: null });
          continue;
        }
        const importo = Number(scritto.replace(',', '.'));
        if (!Number.isFinite(importo) || importo < 0) {
          ElMessage.error(`Compenso non valido: "${scritto}"`);
          return;
        }
        legs.push({ planner_id: leg.planner_id, amount: importo });
      }
      compSaving.value = true;
      try {
        const res = await bookingAPI.setDriverCompensation(booking.value.id, legs);
        compLegs.value = res.data?.legs || [];
        for (const leg of compLegs.value) {
          compDraft[leg.planner_id] = leg.manual === null || leg.manual === undefined
            ? String(leg.computed ?? 0)
            : String(leg.manual);
        }
        ElMessage.success('Compensi salvati');
      } catch (e) {
        console.error('Compensi non salvati:', e);
        const msg = e?.response?.data?.message;
        ElMessage.error(Array.isArray(msg) ? msg.join(', ') : msg || 'Compensi non salvati');
      } finally {
        compSaving.value = false;
      }
    };

    const suppliers = ref([]);
    const suppliersLoading = ref(false);
    const rentalDialog = ref(false);
    const savingRental = ref(false);
    const rentalDraft = ref({ supplierId: '', vehicleType: '', rentalDate: '', cost: null });

    const openRental = async () => {
      rentalDraft.value = {
        supplierId: '',
        // preimpostati da quello che già sappiamo della prenotazione
        vehicleType: booking.value.vehicle_type || '',
        rentalDate: String(booking.value.data || '').slice(0, 10),
        cost: null,
      };
      rentalDialog.value = true;
      if (suppliers.value.length) return;
      suppliersLoading.value = true;
      try {
        suppliers.value = await supplierAPI.getSuppliers({ onlyActive: true });
      } catch (e) {
        console.warn('Fornitori non disponibili:', e?.message);
        suppliers.value = [];
      } finally {
        suppliersLoading.value = false;
      }
    };

    const saveRental = async () => {
      savingRental.value = true;
      try {
        await supplierAPI.createRental({
          bookingId: booking.value.id,
          supplierId: rentalDraft.value.supplierId,
          vehicleType: rentalDraft.value.vehicleType,
          rentalDate: rentalDraft.value.rentalDate,
          cost: rentalDraft.value.cost,
        });
        ElMessage.success('Noleggio registrato.');
        rentalDialog.value = false;
        await loadRentals();
      } catch (e) {
        console.error('Registrazione noleggio fallita:', e);
        ElMessage.error(
          e?.response?.status === 403
            ? 'Operazione riservata ai ruoli globali.'
            : 'Registrazione non riuscita',
        );
      } finally {
        savingRental.value = false;
      }
    };

    // Famiglia di servizio: decide gli stati impostabili e il tipo di slot.
    const family = computed(() => {
      const t = booking.value.type_prenotazione;
      if (t === 'delivery') return 'delivery';
      if (t === 'escort' || t === 'escort_loaner') return 'escort';
      if (t === 'pickup_loaner' || booking.value.loaner) return 'pickup_loaner';
      return 'pickup';
    });

    const partnerName = computed(() =>
      booking.value.headquarter?.partner?.company_name || '');
    const hqAddress = computed(() => place(booking.value.headquarter));
    // Nome e cognome di un dipendente; vuoto se non c'è.
    const nomeDipendente = (p) => (p ? `${p.name || ''} ${p.surname || ''}`.trim() : '');
    const customerName = computed(() =>
      [booking.value.customer?.name, booking.value.customer?.surname]
        .filter(Boolean).join(' ') || '—');
    const initials = computed(() =>
      customerName.value.trim().split(/\s+/).slice(0, 2)
        .map((w) => w[0]).join('').toUpperCase().replace('—', '?') || '?');
    const carLabel = computed(() =>
      [booking.value.car?.marca, booking.value.car?.modello]
        .filter(Boolean).join(' ') || '—');

    const loanerBanner = computed(() => {
      if (!booking.value.loaner) return '';
      return booking.value.type_prenotazione === 'escort_loaner'
        ? 'Il driver ha in dotazione la vettura del partner.'
        : "Il driver ritira e consegna l'auto di cortesia.";
    });

    const tasks = computed(() => booking.value.tasks || []);
    const tasksTotal = computed(() =>
      tasks.value.reduce((s, t) => s + Number(t.cost || 0), 0));

    // Saldato = `accepted`. `pay` dice soltanto che la voce è pagabile in app.
    const tasksDue = computed(() => tasks.value
      .filter((t) => !t.accepted)
      .reduce((s, t) => s + Number(t.cost || 0), 0));

    const taskState = (t) => {
      if (t.accepted) return { kind: 'ok', label: 'Saldato' };
      if (t.pay) return { kind: 'attn', label: 'Da saldare' };
      return { kind: 'muted', label: 'Da accettare' };
    };

    // La nota oggi è testo libero. Le prenotazioni della vecchia app la
    // salvavano come CSV: i primi quattro campi descrivono l'auto, il quinto
    // è la nota del cliente in forma "etichetta: testo". Si legge come CSV
    // solo se ha QUELLA forma: una nota libera con delle virgole finiva
    // spezzata e mostrata come «Descrizione auto».
    const noteParts = computed(() => {
      const raw = booking.value.note;
      if (!raw) return { car: '', carRaw: '', text: '' };
      const parts = String(raw).split(',');
      if (parts.length < 5 || !parts[4].includes(':')) {
        return { car: '', carRaw: '', text: String(raw).trim() };
      }
      return {
        car: parts.slice(0, 4).filter(Boolean).join(', ').trim(),
        carRaw: parts.slice(0, 4).join(','),
        text: parts.slice(4).join(',').split(':').slice(1).join(':').trim(),
      };
    });
    const carDescription = computed(() => noteParts.value.car);
    const note = computed(() => noteParts.value.text);

    // ---- tratte ----------------------------------------------------------
    // Le tre collezioni hanno punti con nomi diversi; il PICKUP ne ha uno
    // solo (casa del cliente) e l'altro capo è sempre la sede del partner.
    //
    // ⚠️ origin/destination del payload NON seguono la direzione: per il
    // pickup l'origine è sempre la sede e la destinazione sempre il punto del
    // cliente, come si aspetta il calcolo degli slot. Non invertirli.
    const toLeg = (raw, kind) => {
      const direction = raw.type_booking === 'return' ? 'return' : 'gone';
      const hq = booking.value.headquarter;
      const hqPlace = place(hq) || hq?.name || 'Sede partner';

      let originPoint;
      let destinationPoint;
      let from;
      let to;

      if (kind === 'pickup') {
        originPoint = hq;
        destinationPoint = raw.point;
        const home = place(raw.point);
        from = direction === 'gone' ? home : hqPlace;
        to = direction === 'gone' ? hqPlace : home;
      } else if (kind === 'escort') {
        originPoint = raw.point_origin_escort;
        destinationPoint = raw.point_destination_escort;
        from = place(originPoint);
        to = place(destinationPoint);
      } else {
        originPoint = raw.point_origin_delivery;
        destinationPoint = raw.point_destination_delivery;
        from = place(originPoint);
        to = place(destinationPoint);
      }

      const slotFamily = kind === 'escort' && booking.value.loaner
        ? 'escort_loaner'
        : kind === 'pickup'
          ? family.value
          : kind;

      // Il driver assegnato vive sulla tratta, con un nome di colonna diverso
      // per collezione. `is_alive` vale il contrario del nome: operativo è
      // false (vedi driverAPI), quindi non si filtra su quello — se la tratta
      // ha un driver, va mostrato.
      const rawDriver = raw.driver_pickup || raw.driver_escort || raw.driver_delivery;

      // PARTENZA e ARRIVO dipendono dalla direzione (regola confermata):
      //   andata  -> parte da date_customer, arriva a date_partner
      //   ritorno -> l'inverso (anche sul transfer: sede → casa)
      // `date` resta date_partner perché il dialog "Modifica data e ora"
      // lavora sul partnerTime (è ciò che l'endpoint degli slot si aspetta).
      const depart = kind === 'delivery'
        ? raw.date_point
        : direction === 'gone' ? raw.date_customer : raw.date_partner;
      const arrive = kind === 'delivery'
        ? null
        : direction === 'gone' ? raw.date_partner : raw.date_customer;

      return {
        id: raw.id,
        kind,
        direction,
        // L'app driver ha già registrato la partenza: l'indirizzo non si cambia.
        started: !!(raw.true_date_driver || raw.true_date_customer),
        driver: rawDriver ? [rawDriver.name, rawDriver.surname].filter(Boolean).join(' ') : '',
        title: kind === 'pickup' ? 'Tratta pickup'
          : kind === 'escort' ? 'Tratta transfer' : 'Tratta delivery',
        date: kind === 'delivery' ? raw.date_point || raw.date_partner : raw.date_partner,
        depart,
        arrive,
        kmRange: raw.simba_km_range,
        km: raw.simba_km,
        from,
        to,
        originPoint,
        destinationPoint,
        slotType: SLOT_TYPE[slotFamily]?.[direction],
        // Sempre prima il conducente e poi il jolly: in ordine sparso è
        // facile assegnare la persona al ruolo sbagliato.
        planners: planners.value
          .filter((p) => p.raceId === raw.id)
          .sort((a, b) => Number(!a.isDriver) - Number(!b.isDriver)),
      };
    };

    const legs = computed(() => {
      const b = booking.value;
      const out = [
        ...(b.pickup_bookings || []).map((l) => toLeg(l, 'pickup')),
        ...(b.escort_bookings || []).map((l) => toLeg(l, 'escort')),
        ...(b.delivery_bookings || []).map((l) => toLeg(l, 'delivery')),
      ];
      // andata prima del ritorno, poi per orario
      return out.sort((a, x) => {
        if (a.direction !== x.direction) return a.direction === 'gone' ? -1 : 1;
        return new Date(a.date || 0) - new Date(x.date || 0);
      });
    });

    // I planner che non corrispondono a nessuna tratta restano assegnabili:
    // finiscono qui invece di sparire.
    const orphanPlanners = computed(() => {
      const known = new Set(legs.value.map((l) => l.id));
      return planners.value.filter((p) => !known.has(p.raceId));
    });

    const kmBandRows = computed(() => {
      const withKm = legs.value.filter((l) => l.kmRange || l.km);
      if (!withKm.length) return [{ key: 'none', label: 'Fascia km', value: '—' }];
      const fmt = (l) => [
        l.kmRange ? `fino a ${l.kmRange} km` : '',
        l.km ? `(${l.km} km)` : '',
      ].filter(Boolean).join(' ');
      const same = withKm.every((l) => l.kmRange === withKm[0].kmRange && l.km === withKm[0].km);
      if (same) return [{ key: 'all', label: 'Fascia km', value: fmt(withKm[0]) }];
      return withKm.map((l) => ({
        key: l.id,
        label: `Fascia km · ${l.direction === 'return' ? 'ritorno' : 'andata'}`,
        value: fmt(l),
      }));
    });

    const hasReturn = computed(() => legs.value.some((l) => l.direction === 'return'));
    const hasGone = computed(() => legs.value.some((l) => l.direction === 'gone'));

    const stateOptions = computed(() => {
      const map = STATE_OPTIONS[family.value];
      if (!map) return [];
      const out = [];
      if (hasGone.value) out.push(...map.gone);
      else out.push(ACCEPTED);
      if (hasReturn.value) out.push(...map.return);
      out.push({ value: 'end', label: 'Concluso' });
      return out;
    });

    // ---- cambio indirizzo, cliente e auto (solo Simba) --------------------
    const bookingAperta = computed(() => !['end', 'canceled'].includes(booking.value.state));
    const addrDialog = ref(false);
    const addrLeg = ref(null);
    const custDialog = ref(false);
    const partnerDialog = ref(false);
    const puoCambiarePartner = computed(() =>
      !!booking.value.id && booking.value.state !== 'canceled' && !booking.value.liquidato);
    // Il delivery è deprecato; una tratta già partita non cambia strada.
    const puoCambiareIndirizzo = (leg) =>
      bookingAperta.value && leg.kind !== 'delivery' && !leg.started;
    const openAddrDialog = (leg) => {
      addrLeg.value = leg;
      addrDialog.value = true;
    };

    // ---- modifica dei dati della prenotazione -----------------------------
    const editDialog = ref(false);
    const editKind = ref('');
    const savingEdit = ref(false);
    const editDraft = reactive({ note: '', vehicleType: null, passengers: null, lordo: '' });
    const editTitle = computed(() => ({
      note: 'Modifica le note',
      mezzo: 'Modifica mezzo e passeggeri',
      prezzo: 'Modifica il prezzo del Transfer',
    })[editKind.value] || '');

    const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
    // «1.234,50», «1234,50» e «1234.50» valgono uguale: con la virgola i
    // punti sono migliaia, senza il punto è il decimale.
    const lordoNumero = computed(() => {
      const t = String(editDraft.lordo ?? '').trim();
      const v = Number(t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t);
      return Number.isFinite(v) ? round2(v) : NaN;
    });
    const lordoValido = computed(() => editDraft.lordo !== '' && lordoNumero.value > 0);
    const imponibileDaLordo = computed(() => round2(lordoNumero.value / 1.22));

    const troppiPasseggeri = computed(() => {
      const posti = vehicleOf(editDraft.vehicleType)?.seats;
      return posti && editDraft.passengers > posti
        ? `${editDraft.passengers} passeggeri su un mezzo da ${posti} posti.`
        : '';
    });

    const openEdit = (kind) => {
      editKind.value = kind;
      editDraft.note = note.value;
      editDraft.vehicleType = booking.value.vehicle_type || null;
      editDraft.passengers = booking.value.passengers ?? null;
      editDraft.lordo = booking.value.tot_fattura != null
        ? Number(booking.value.tot_fattura).toFixed(2).replace('.', ',')
        : '';
      editDialog.value = true;
    };

    const saveEdit = async () => {
      const b = booking.value;
      savingEdit.value = true;
      try {
        if (editKind.value === 'note') {
          const testo = String(editDraft.note || '').trim();
          // Una nota della vecchia app tiene la sua descrizione dell'auto.
          const nota = noteParts.value.carRaw
            ? `${noteParts.value.carRaw},Note: ${testo}`
            : testo;
          await bookingAPI.updateBooking(b.id, { note: nota });
        } else if (editKind.value === 'mezzo') {
          await bookingAPI.updateBooking(b.id, {
            vehicle_type: editDraft.vehicleType || null,
            passengers: editDraft.passengers ?? null,
          });
        } else if (editKind.value === 'prezzo') {
          await bookingAPI.setPricing(b.id, {
            customer_price: imponibileDaLordo.value,
            tot_fattura: lordoNumero.value,
          });
        }
        ElMessage({ type: 'success', message: 'Modifica salvata.' });
        editDialog.value = false;
        await load();
      } catch (e) {
        // il messaggio del server lo mostra l'interceptor di API.js
        console.error('Modifica prenotazione non salvata:', e?.response?.status);
      } finally {
        savingEdit.value = false;
      }
    };

    // ---- caricamento -----------------------------------------------------
    const load = async () => {
      loading.value = true;
      try {
        const [b, pl] = await Promise.allSettled([
          bookingAPI.getBookingById(id),
          driverAPI.getPlannersByBookingId(id),
        ]);

        if (b.status === 'fulfilled') {
          booking.value = b.value.data || {};
          // La select lavora sull'enum, non sull'etichetta italiana.
          stateDraft.value = booking.value.state || '';
          // I noleggi si chiedono solo per i Transfer, e solo ora che si sa
          // di che servizio si tratta.
          loadRentals();
          loadCompensations();
        } else {
          console.error('Booking non caricato:', b.reason);
        }

        if (pl.status === 'fulfilled') {
          // Il backend, su errore, arrivava a rispondere `{}` con HTTP 200:
          // trattarlo come lista mandava in TypeError l'intera pagina. Ora il
          // backend fa 404, ma la difesa resta.
          const rawPlanners = Array.isArray(pl.value.data) ? pl.value.data : [];
          plannersError.value = Array.isArray(pl.value.data)
            ? ''
            : 'risposta inattesa dal server';
          planners.value = rawPlanners.map((p) => ({
            plannerId: p.plannerId,
            raceId: p.raceId,
            data_inizio: p.data_inizio,
            data_fine: p.data_fine,
            itinerario: p.itinerario,
            isDriver: p.type === 'driver',
            // `is_alive` sui driver vale il contrario del nome: operativo è
            // false (vedi la nota in driverAPI). Un driver non operativo non
            // va preselezionato.
            driverId: driverAPI.isOperativo(p.driver) ? p.driver?.id || '' : '',
          }));
        } else {
          plannersError.value = pl.reason?.response?.status
            ? `errore ${pl.reason.response.status}`
            : pl.reason?.message || 'errore di rete';
          console.warn('Planner non caricati:', pl.reason);
        }

        await loadDrivers();
      } finally {
        loading.value = false;
      }
    };

    // I driver assegnabili sono quelli che coprono la sede.
    //
    // ⚠️ Si guarda la PROVINCIA, come fa il planner (`driversForZone`): l'area
    // è la vecchia zona e le sedi create dal gestionale nuovo non ce l'hanno.
    // Con il solo filtro per area la tendina restava vuota e sembrava che non
    // ci fossero driver. L'area resta come ripiego per le sedi vecchie.
    const driversError = ref('');
    const loadDrivers = async () => {
      const hq = booking.value.headquarter;
      driversError.value = '';
      try {
        if (hq?.province_ref?.id) {
          const r = await driverAPI.getDriversByProvince(hq.province_ref.id);
          drivers.value = r.data?.data ?? r.data ?? [];
        } else if (hq?.area?.id) {
          const r = await driverAPI.getDriverByHeadquarterAreaId(hq.area.id);
          drivers.value = r.data?.data ?? r.data ?? [];
        } else {
          drivers.value = [];
          driversError.value = 'La sede non ha una provincia: assegnala nella scheda della sede, '
            + 'altrimenti non si possono cercare i driver.';
          return;
        }
        if (!drivers.value.length && hq?.province_ref?.id) {
          driversError.value = `Nessun driver operativo copre la provincia ${hq.province || ''}`.trim() + '.';
        }
      } catch (e) {
        console.warn('Driver della zona non caricati:', e?.message);
        driversError.value = 'Driver non caricati: riprova.';
      }
    };

    // ---- azioni ----------------------------------------------------------
    const saveState = async () => {
      savingState.value = true;
      try {
        const res = await bookingAPI.patchBooking({ id: booking.value.id, state: stateDraft.value });
        // PATCH /state risponde HTTP 200 ANCHE QUANDO FALLISCE, con
        // { stato: 'reject' } nel corpo: va letto il corpo.
        if (res?.data?.stato !== 'accepted') {
          ElMessage.error('Stato non aggiornato: il server ha rifiutato il cambio.');
          stateDraft.value = booking.value.state;
          return;
        }
        booking.value.state = stateDraft.value;
        ElMessage.success('Stato aggiornato.');
      } catch (e) {
        console.error('Stato non aggiornato:', e);
      } finally {
        savingState.value = false;
      }
    };

    // ⚠️ L'unica scrittura sull'assegnazione è questa: cambia il driver di un
    // planner ESISTENTE. I planner (e i loro orari) li produce il motore alla
    // creazione della prenotazione e non vanno né creati né toccati da qui.
    const saveDriver = async (pl) => {
      savingPlanner.value = pl.plannerId;
      try {
        // Il payload contiene anche campi che il controller ignora.
        await driverAPI.postDriverAssign({
          data_fine: pl.data_fine,
          data_inizio: pl.data_inizio,
          itinerario: pl.itinerario,
          plannerId: pl.plannerId,
          driverId: pl.driverId,
          raceId: pl.raceId,
          type: pl.isDriver ? 'driver' : 'jolly',
        });
        ElMessage.success(`${pl.isDriver ? 'Driver' : 'Jolly'} assegnato.`);
      } catch (e) {
        console.error('Assegnazione non riuscita:', e);
      } finally {
        savingPlanner.value = '';
      }
    };

    // La data va letta in ora LOCALE come tutto il resto della pagina:
    // toISOString() è UTC e per una tratta notturna sposterebbe il giorno.
    const isoDay = (v) => {
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return '';
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    const openDateDialog = (leg) => {
      dateLeg.value = leg;
      newDate.value = leg.date ? isoDay(leg.date) : '';
      newSlot.value = '';
      slots.value = ALL_SLOTS.map((v) => ({ value: v, disabled: true }));
      if (newDate.value) reloadSlots();
      dateDialog.value = true;
    };

    // Gli orari liberi li calcola il backend sul percorso della tratta.
    const reloadSlots = async () => {
      newSlot.value = '';
      if (!newDate.value || !dateLeg.value) return;
      slotsLoading.value = true;
      try {
        const r = await prenotazioneAPI.calcSlot({
          originPoint: dateLeg.value.originPoint,
          destinationPoint: dateLeg.value.destinationPoint,
          partnerDay: newDate.value,
          type: dateLeg.value.slotType,
          // I driver si cercano per provincia della sede: senza l'id le sedi
          // nuove, che non hanno la vecchia area, non trovano nessun orario.
          headquarterId: booking.value.headquarter?.id,
          area: booking.value.headquarter?.area,
        });
        const free = Array.isArray(r.data) ? r.data : [];
        slots.value = ALL_SLOTS.map((v) => ({ value: v, disabled: !free.includes(v) }));
      } catch (e) {
        console.error('Slot non calcolati:', e);
        slots.value = ALL_SLOTS.map((v) => ({ value: v, disabled: true }));
      } finally {
        slotsLoading.value = false;
      }
    };

    const freeSlotCount = computed(() => slots.value.filter((s) => !s.disabled).length);

    const dateDialogTitle = computed(() =>
      dateLeg.value?.direction === 'return' ? 'Modifica il ritorno' : "Modifica l'andata");

    const updateLegDate = (leg, when) => {
      const payload = {
        originPoint: leg.originPoint,
        destinationPoint: leg.destinationPoint,
        partnerTime: when,
        type: leg.slotType,
        headquarterId: booking.value.headquarter?.id,
        area: booking.value.headquarter?.area,
      };
      if (leg.kind === 'pickup') return bookingAPI.updateDatePickup(leg.id, payload);
      if (leg.kind === 'escort') return bookingAPI.updateDateEscort(leg.id, payload);
      return bookingAPI.updateDateDelivery(leg.id, payload);
    };

    const saveDate = async () => {
      const leg = dateLeg.value;
      // istante vero, non orologio da parete (vedi services/datetime.js)
      const when = toInstant(newDate.value, newSlot.value);
      savingDate.value = true;
      try {
        const res = await updateLegDate(leg, when);
        // update-prenotazione risponde 201 ANCHE QUANDO FALLISCE, con
        // { stato: 'reject' } nel corpo: ci si ferma prima di aggiornare la data
        // del booking e di avvisare il cliente.
        if (res?.data?.stato !== 'accepted') {
          ElMessage.error(
            "Spostamento non riuscito: per il nuovo orario non c'è copertura "
            + "(di solito nessun driver libero in zona). La tratta resta com'era.",
          );
          return;
        }

        // La data del booking segue l'andata: se si sposta il ritorno di un
        // A/R la testata non cambia.
        if (leg.direction === 'gone' || !hasGone.value) {
          await bookingAPI.updateDateBooking(booking.value.id, { data: when });
        }

        // Notifica al cliente, con la tratta toccata.
        await bookingAPI.messageModifyHourBooking({
          customer: booking.value.customer,
          booking: booking.value,
          type: leg.direction, // 'gone' | 'return'
          goneDriver: driverOfDirection('gone'),
          returnDriver: driverOfDirection('return'),
          newDateGone: leg.direction === 'gone' ? when : null,
          newDateReturn: leg.direction === 'return' ? when : null,
        });

        ElMessage.success('Tratta spostata, cliente avvisato.');
        dateDialog.value = false;
        await load();
      } catch (e) {
        console.error('Spostamento non riuscito:', e);
      } finally {
        savingDate.value = false;
      }
    };

    // Il driver della tratta sta sulla collezione, non sul planner.
    const driverOfDirection = (direction) => {
      const b = booking.value;
      const all = [
        ...(b.pickup_bookings || []).map((l) => [l, l.driver_pickup]),
        ...(b.escort_bookings || []).map((l) => [l, l.driver_escort]),
        ...(b.delivery_bookings || []).map((l) => [l, l.driver_delivery]),
      ];
      const hit = all.find(([l]) =>
        (l.type_booking === 'return' ? 'return' : 'gone') === direction);
      return hit ? hit[1] || null : null;
    };

    const confirmDelete = () => {
      ElMessageBox.confirm(
        'La prenotazione viene eliminata. Vuoi procedere?',
        'Elimina prenotazione',
        { confirmButtonText: 'Elimina', cancelButtonText: 'Annulla', type: 'warning' },
      ).then(async () => {
        try {
          await bookingAPI.deleteBooking(booking.value.id);
          ElMessage.success('Prenotazione eliminata.');
          router.push('/booking');
        } catch (e) {
          console.error('Eliminazione non riuscita:', e);
        }
      }).catch(() => {});
    };

    // ---- navigazione e formattazione -------------------------------------
    const goBack = () => router.push('/booking');
    const openCustomer = () => router.push(`/customer/detail/${booking.value.customer.id}`);

    // ⚠️ ORA LOCALE, una sola volta per tutta la pagina: pickup, escort e
    // delivery usano la stessa colonna `datetime`.
    const hhmm = (v) => {
      if (!v) return '—';
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return '—';
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    const dLabel = (v) => {
      if (!v) return '—';
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return '—';
      return d.toLocaleDateString('it-IT', {
        weekday: 'short', day: '2-digit', month: 'long', year: 'numeric',
      });
    };

    const euro = (n) => `€ ${Number(n || 0).toFixed(2).replace('.', ',')}`;

    const ini = (name) => (name || '').trim().split(/\s+/).slice(0, 2)
      .map((w) => w[0]).join('').toUpperCase() || '?';

    // ---- foto e allegati -------------------------------------------------
    const photoGroups = ref([]);
    const attachments = ref([]);
    const mediaLoading = ref(false);
    const mediaError = ref('');

    const photoCount = computed(() =>
      photoGroups.value.reduce((n, g) => n + g.urls.length, 0));

    // Una riga `image` → i suoi URL pre-firmati. Le righe arrivano già
    // filtrate per chiave dello storage: tutte hanno almeno una key.
    const urlsOfImage = async (img) => {
      const u = await bookingAPI.getImageUrls(img.id);
      return [u.url1, u.url2, u.url3, u.url4].filter(Boolean);
    };

    const loadMedia = async () => {
      mediaLoading.value = true;
      mediaError.value = '';
      const failures = [];
      // Motivo leggibile: senza, un 500 del server qui resta un mistero.
      const why = (what, e) => {
        const st = e?.response?.status;
        const msg = e?.response?.data?.message;
        const detail = Array.isArray(msg) ? msg.join(', ') : msg;
        return `${what}${st ? ` (errore ${st}${detail ? `: ${detail}` : ''})` : ''}`;
      };

      // Il transfer non ha foto a slot: solo pickup e delivery.
      const photoLegs = legs.value.filter((l) => l.kind === 'pickup' || l.kind === 'delivery');
      const groups = await Promise.all(photoLegs.map(async (leg) => {
        try {
          const rows = await bookingAPI.getRaceImages(leg.kind, leg.id);
          const urls = (await Promise.all(rows.map(urlsOfImage))).flat();
          if (!urls.length) return null;
          return {
            key: leg.id,
            title: `${leg.direction === 'return' ? 'Ritorno' : 'Andata'} · ${leg.title}`,
            urls,
          };
        } catch (e) {
          console.warn('Foto della tratta non caricate:', e?.config?.url, e);
          failures.push(why('le foto', e));
          return null;
        }
      }));
      photoGroups.value = groups.filter(Boolean);

      try {
        const list = await bookingAPI.getAttachments(id);
        attachments.value = Array.isArray(list) ? list : [];
      } catch (e) {
        console.warn('Allegati non caricati:', e?.config?.url, e);
        attachments.value = [];
        failures.push(why('gli allegati', e));
      }

      if (failures.length) {
        mediaError.value = `Non è stato possibile caricare ${[...new Set(failures)].join(' e ')}.`;
      }
      mediaLoading.value = false;
    };

    // ---- allegati caricati da qui ------------------------------------------
    const uploadingAttachment = ref(false);
    const rileggiAllegati = async () => {
      try {
        const list = await bookingAPI.getAttachments(booking.value.id || id);
        attachments.value = Array.isArray(list) ? list : [];
      } catch (e) {
        console.warn('Allegati non riletti:', e?.message);
      }
    };
    const caricaAllegato = async (file) => {
      if (troppoGrande(file)) {
        ElMessage.warning(`Il file supera i ${MAX_ALLEGATO_MB} MB.`);
        return;
      }
      uploadingAttachment.value = true;
      try {
        const dataUri = await leggiComeDataUri(file);
        await bookingAPI.uploadAttachment(booking.value.id, { file: dataUri, fileName: file.name });
        ElMessage.success('Allegato caricato.');
        await rileggiAllegati();
      } catch (e) {
        // il messaggio del server lo mostra l'interceptor di API.js
        console.error('Allegato non caricato:', e?.response?.status, e?.message);
      } finally {
        uploadingAttachment.value = false;
      }
    };
    const eliminaAllegato = async (allegato) => {
      try {
        await ElMessageBox.confirm(`Eliminare «${allegato.file_name}»?`, 'Elimina allegato', {
          confirmButtonText: 'Elimina', cancelButtonText: 'Annulla', type: 'warning',
        });
      } catch {
        return;
      }
      try {
        await bookingAPI.deleteAttachment(booking.value.id, allegato.id);
        ElMessage.success('Allegato eliminato.');
        await rileggiAllegati();
      } catch (e) {
        console.error('Allegato non eliminato:', e?.response?.status);
      }
    };

    onMounted(async () => {
      await load();
      loadMedia();
    });
    // Solo restando su una prenotazione: andando per esempio sulla scheda del
    // cliente (/customer/detail/:id) l'id cambia anche per la pagina che esce.
    watch(() => route.params.id, async (next, prev) => {
      if (!next || next === prev || !route.path.startsWith('/booking/detail/')) return;
      id = next;
      dateDialog.value = false;
      await load();
      loadMedia();
    });

    return {
      photoGroups, attachments, photoCount, mediaLoading, mediaError, kmBandRows,
      booking, planners, drivers, driversError, loading, legs, tasks, tasksTotal,
      tasksDue, taskState,
      shortId, headState, stateDetail, service, partnerName, hqAddress, nomeDipendente,
      customerName, initials, carLabel, loanerBanner, carDescription, note,
      stateOptions, stateDraft, savingState, savingPlanner, plannersError,
      dateDialog, dateLeg, newDate, newSlot, slots, slotsLoading, savingDate,
      freeSlotCount, dateDialogTitle, orphanPlanners,
      saveState, saveDriver, openDateDialog, reloadSlots, saveDate,
      confirmDelete, goBack, openCustomer,
      hhmm, dLabel, euro, ini,
      isTransfer, vehicleLabel, vehicleLabelOf, isRentableVehicle, VEHICLES,
      rentals, rentalsLoading, rentalsForbidden, rentalsTotal,
      suppliers, suppliersLoading, rentalDialog, rentalDraft, savingRental,
      openRental, saveRental,
      compLegs, compDraft, compLoading, compSaving, compForbidden,
      compTotal, compComputedTotal, saveCompensations,
      editDialog, editKind, editTitle, editDraft, savingEdit, openEdit, saveEdit,
      bookingAperta, addrDialog, addrLeg, custDialog, partnerDialog, puoCambiarePartner, puoCambiareIndirizzo, openAddrDialog, load,
      uploadingAttachment, caricaAllegato, eliminaAllegato, MAX_ALLEGATO_MB,
      lordoNumero, lordoValido, imponibileDaLordo, troppiPasseggeri,
    };
  },
};
</script>

<style scoped>
.bkd { padding: 4px 0 32px; }
.bkd__spacer { flex: 1; }
.bkd__hint--warn { color: #92400e; background: #fffbeb; border-radius: 6px; padding: 8px 10px; }

/* ---- intestazione ---- */
.bkd__head {
  display: flex; align-items: center; gap: 14px; flex-wrap: wrap; margin-bottom: 12px;
}
.bkd__back {
  width: 36px; height: 36px; flex: none; border-radius: 9px;
  border: 1px solid var(--border-color); background: var(--bg-primary);
  display: grid; place-items: center; cursor: pointer;
  font-size: 16px; color: var(--text-secondary); font-family: inherit;
}
.bkd__back:hover { border-color: var(--brand-violet); }
.bkd__ident { min-width: 0; }
.bkd__title {
  margin: 0; font-size: 21px; display: flex; align-items: center; gap: 10px;
  flex-wrap: wrap; color: var(--text-primary);
}
.bkd__sub {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  margin-top: 5px; font-size: 12.5px; color: var(--text-tertiary);
}
.bkd__id { font-variant-numeric: tabular-nums; color: var(--brand-violet); }
.bkd__actions { display: flex; gap: 8px; flex-wrap: wrap; }

.bkd__stateNow {
  display: flex; align-items: center; gap: 8px; margin-bottom: 14px;
  font-size: 13px; color: var(--text-secondary);
}
.bkd__stateDot {
  width: 7px; height: 7px; border-radius: 50%; background: var(--state-active);
}

.warnbox {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 10px 13px; margin-bottom: 14px;
  border-radius: 9px; font-size: 12.5px; line-height: 1.5;
  color: var(--state-attn); background: var(--state-attn-bg);
  border: 1px solid var(--state-attn-line);
}
.warnbox__ico { flex: none; font-size: 14px; line-height: 1.35; }

/* ---- griglia ---- */
.bkd__grid {
  display: grid; grid-template-columns: minmax(0, 1fr) 330px;
  gap: 16px; align-items: start;
}
@media (max-width: 1000px) { .bkd__grid { grid-template-columns: 1fr; } }
.bkd__col { display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.bkd__aside {
  position: sticky; top: 16px; display: flex; flex-direction: column; gap: 16px;
}
@media (max-width: 1000px) { .bkd__aside { position: static; } }

/* ---- card ---- */
.bkd__card {
  background: var(--bg-primary); border: 1px solid var(--border-color);
  border-radius: var(--radius-lg); overflow: hidden;
}
.bkd__cardHead {
  display: flex; align-items: center; gap: 10px; padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
}
.bkd__cardHead h3 { margin: 0; font-size: 14px; color: var(--text-primary); }
.bkd__count {
  font-size: 12px; color: var(--text-tertiary); font-variant-numeric: tabular-nums;
}
.bkd__cardBody { padding: 16px; }
.bkd__empty { margin: 0; font-size: 12.5px; color: var(--text-tertiary); line-height: 1.5; }


/* ---- tratta ---- */
.bkd__legTag {
  font-size: 10.5px; font-weight: 700; letter-spacing: 0.04em;
  text-transform: uppercase; padding: 2px 7px; border-radius: 5px;
  color: var(--state-muted); background: var(--state-muted-bg);
  border: 1px solid var(--state-muted-line);
}
.bkd__legTop {
  display: flex; gap: 18px; align-items: flex-start; flex-wrap: wrap;
  padding-bottom: 14px; border-bottom: 1px solid var(--border-color);
}
.bkd__when { min-width: 130px; }
.bkd__whenD { display: block; font-size: 12px; color: var(--text-tertiary); }
.bkd__whenH {
  display: block; margin-top: 2px; font-size: 24px; font-weight: 750;
  letter-spacing: -0.02em; font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}
.bkd__route { flex: 1; min-width: 220px; display: flex; flex-direction: column; gap: 7px; }
.bkd__pt { display: flex; align-items: flex-start; gap: 9px; }
.bkd__pin { width: 9px; height: 9px; border-radius: 50%; margin-top: 5px; flex: none; }
.bkd__pin--from { background: var(--text-tertiary); }
.bkd__pin--to { background: var(--brand-violet); }
.bkd__addr { font-size: 13px; line-height: 1.35; }
.bkd__km { text-align: right; min-width: 70px; }
.bkd__kmN {
  display: block; font-size: 17px; font-weight: 700;
  font-variant-numeric: tabular-nums; color: var(--text-primary);
}
.bkd__kmL {
  display: block; font-size: 10.5px; font-weight: 600; letter-spacing: 0.05em;
  text-transform: uppercase; color: var(--text-tertiary);
}

/* ---- assegnazione ---- */
.bkd__assignHead {
  display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
  padding-top: 14px;
}
.bkd__assignHead h4 {
  margin: 0; font-size: 11px; font-weight: 700; letter-spacing: 0.05em;
  text-transform: uppercase; color: var(--text-tertiary);
}
.bkd__drv { display: flex; align-items: center; gap: 8px; font-weight: 600; font-size: 13.5px; }
.bkd__drvAva {
  width: 26px; height: 26px; flex: none; border-radius: 50%;
  display: grid; place-items: center; background: var(--avatar-bg);
  color: #fff; font-size: 10px; font-weight: 700;
}
.bkd__unassigned { color: var(--state-attn); font-weight: 650; font-size: 12.5px; }
.bkd__empty--attn { color: var(--state-attn); }
.bkd__assign { padding-top: 12px; display: flex; flex-direction: column; gap: 10px; }
.bkd__assign--flush { padding-top: 0; }
.bkd__mb { margin-bottom: 12px; }
.bkd__pl { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.bkd__plRole {
  flex: none; font-size: 10.5px; font-weight: 700; letter-spacing: 0.04em;
  text-transform: uppercase; padding: 2px 8px; border-radius: 5px;
  color: #fff; background: var(--avatar-bg);
}
.bkd__plRole--jolly { background: var(--svc-fleet); }
.bkd__plWhen {
  font-size: 11.5px; color: var(--text-tertiary);
  font-variant-numeric: tabular-nums; min-width: 210px;
}
.bkd__plSel { flex: 1; min-width: 180px; }

/* ---- stato ---- */
.bkd__stateRow { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }
.bkd__hint { margin: 10px 0 0; font-size: 11.5px; line-height: 1.45; color: var(--text-tertiary); }
.bkd__hint--top { margin: 0 0 14px; }
.bkd__hint--attn { color: var(--state-attn); }

/* ---- task ---- */
.bkd__task {
  display: flex; align-items: center; gap: 10px; padding: 8px 0;
  border-bottom: 1px solid var(--border-color); font-size: 13.5px;
}
.bkd__taskD { flex: 1; min-width: 0; }
.bkd__taskC { font-variant-numeric: tabular-nums; font-weight: 650; }
.bkd__taskApp {
  flex: none; font-size: 10px; font-weight: 700; letter-spacing: 0.04em;
  text-transform: uppercase; padding: 1px 6px; border-radius: 5px;
  color: var(--brand-violet); background: var(--bg-tertiary);
}
.bkd__task--due .bkd__taskD,
.bkd__task--due .bkd__taskC { color: var(--state-attn); font-weight: 700; }
.bkd__task--due { border-bottom: 0; padding-top: 4px; }
.bkd__task--tot {
  border-bottom: 0; border-top: 2px solid var(--border-color);
  margin-top: 2px; padding-top: 11px; font-weight: 700;
}
.bkd__task--tot .bkd__taskC { font-size: 16px; font-weight: 750; }

/* ---- campi ---- */
.bkd__field + .bkd__field { margin-top: 14px; }
.bkd__label {
  display: block; font-size: 10.5px; font-weight: 700; letter-spacing: 0.05em;
  text-transform: uppercase; color: var(--text-tertiary);
}
.bkd__value {
  display: block; margin-top: 3px; font-size: 14px; color: var(--text-primary);
}
.bkd__value--note { white-space: pre-wrap; color: var(--text-secondary); font-size: 13.5px; }

/* ---- riepilogo ---- */
.bkd__cust { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.bkd__avatar {
  width: 40px; height: 40px; flex: none; border-radius: 50%;
  display: grid; place-items: center; background: var(--avatar-bg);
  color: #fff; font-weight: 700; font-size: 14px;
}
.bkd__custName { font-weight: 650; color: var(--text-primary); }
.bkd__kv {
  display: flex; justify-content: space-between; gap: 12px; padding: 6px 0;
  font-size: 13px; border-bottom: 1px solid var(--border-color);
}
.bkd__kv:last-of-type { border-bottom: 0; }
.bkd__kv span { color: var(--text-tertiary); }
.bkd__kv b { color: var(--text-primary); font-weight: 650; text-align: right; }
.bkd__missing { color: var(--state-attn) !important; font-weight: 600 !important; }

/* mezzo e noleggi del Transfer */
.bkd__rentals { margin-top: 14px; padding-top: 12px; border-top: 1px dashed var(--border-color); }
.bkd__rentalsHead {
  display: flex; align-items: center; gap: 10px; margin-bottom: 10px;
  font-size: 10.5px; font-weight: 700; letter-spacing: 0.05em;
  text-transform: uppercase; color: var(--text-tertiary);
}
.bkd__rental {
  display: flex; align-items: center; gap: 12px; padding: 9px 0;
  border-bottom: 1px solid var(--border-color);
}
.bkd__rental:last-of-type { border-bottom: 0; }
.bkd__rentalMain { flex: 1; min-width: 0; }
.bkd__rentalMain b { color: var(--text-primary); font-size: 13px; }
.bkd__rentalMeta { display: block; font-size: 11.5px; color: var(--text-tertiary); }
.bkd__rentalCost { font-variant-numeric: tabular-nums; color: var(--text-primary); font-weight: 650; }
.bkd__comp {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 0; border-bottom: 1px solid var(--bkd-line, #eceff3);
}
.bkd__comp:last-of-type { border-bottom: 0; }
.bkd__compMain { display: flex; flex-direction: column; min-width: 0; flex: 1; }
.bkd__compMeta { font-size: 12px; color: #6b7280; }
.bkd__compInput { width: 110px; flex: none; }

.bkd__rentalTot {
  display: flex; justify-content: space-between; margin-top: 10px; padding-top: 10px;
  border-top: 2px solid var(--border-color); font-size: 13px; color: var(--text-secondary);
}
.bkd__rentalTot b { font-variant-numeric: tabular-nums; color: var(--text-primary); }

/* dialogo noleggio */
.bkd__form { display: flex; flex-direction: column; gap: 12px; }
.bkd__grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.bkd__fld label {
  display: block; margin-bottom: 4px; font-size: 10.5px; font-weight: 700;
  letter-spacing: 0.05em; text-transform: uppercase; color: var(--text-tertiary);
}
.bkd__opt { text-transform: none; letter-spacing: 0; font-weight: 500; }
.bkd__plate {
  font-variant-numeric: tabular-nums; letter-spacing: 0.04em;
  border: 1px solid var(--border-color); border-radius: 4px; padding: 0 6px;
}
.bkd__addrSmall {
  margin: 8px 0 0; font-size: 12px; line-height: 1.45; color: var(--text-tertiary);
}
.bkd__wide { width: 100%; margin-top: 12px; }

/* ---- dialog ---- */
.bkd__form { display: flex; flex-direction: column; gap: 14px; }
.bkd__formField label {
  display: block; margin-bottom: 4px; font-size: 11px; font-weight: 700;
  letter-spacing: 0.05em; text-transform: uppercase; color: var(--text-tertiary);
}
</style>
